module.exports = __webpack_public_path__ + "static/media/skeleton.f0bc008a.gif";